export const USER_INIT = 'USER_INIT';
export const USER_FAIL = 'USER_FAIL';
export const FETCH_USERS = 'FETCH_USERS';
export const CREATE_USER = 'CREATE_USER';
